"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js").default;
var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/vercel/path0/node_modules/@babel/runtime/helpers/createSuper.js").default;
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedisQuotaManager = void 0;
var util_1 = require("../util");
var quotaManager_1 = require("./quotaManager");
/** QuotaManager that coordinates rate limits across servers. */
var RedisQuotaManager = /*#__PURE__*/function (_quotaManager_1$Quota) {
  _inherits(RedisQuotaManager, _quotaManager_1$Quota);
  var _super = _createSuper(RedisQuotaManager);
  /**
   * @param channelQuota the overall quota to be split among all clients
   * @param channelName unique name for this quota - the Redis pub/sub channel name
   * @param client a Redis client (or a pair of Redis clients if using a specialty Redis library)
   * @param heartbeatInterval how often to ping the Redis channel (milliseconds)
   */
  function RedisQuotaManager(channelQuota, channelName, client) {
    var _this;
    var heartbeatInterval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 30000;
    _classCallCheck(this, RedisQuotaManager);
    // start with 0 concurrency so jobs don’t run until we’re ready
    _this = _super.call(this, Object.assign({}, channelQuota, {
      concurrency: channelQuota.fastStart ? channelQuota.concurrency : 0
    }));
    _this.channelQuota = channelQuota;
    _this.heartbeatInterval = heartbeatInterval;
    _this.uniqueId = util_1.uniqueId();
    _this.pingsReceived = new Map();
    _this.heartbeatTimer = null;
    _this._ready = Boolean(channelQuota.fastStart);
    _this.channelName = "ratelimit-".concat(channelName);
    var clients = Array.isArray(client) ? client : [client];
    if (clients.length === 1) {
      _this.client = clients[0];
      if (typeof _this.client['duplicate'] !== 'function') {
        var msg = '[p-ratelimit RedisQuotaManager] Your Redis client does not ' + 'support the client.duplicate() function. Please provide an array of two ' + 'clients instead.';
        throw new Error(msg);
      }
      _this.pubSubClient = _this.client['duplicate']();
    } else {
      _this.client = clients[0];
      _this.pubSubClient = clients[1];
    }
    _this.register();
    return _this;
  }
  /** true once the Quota Manager has discovered its peers and calculated its quota */
  _createClass(RedisQuotaManager, [{
    key: "ready",
    get: function get() {
      return this._ready;
    }
    /** Join the client pool, coordinated by the shared channel on Redis */
  }, {
    key: "register",
    value: function register() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.pingsReceived.set(this.uniqueId, Date.now());
              this.pubSubClient.on('message', function (channel, message) {
                return _this2.message(channel, message);
              });
              _context.next = 4;
              return util_1.promisify(this.pubSubClient['subscribe'].bind(this.pubSubClient))(this.channelName);
            case 4:
              this.ping();
              if (this.channelQuota.fastStart) {
                _context.next = 8;
                break;
              }
              _context.next = 8;
              return util_1.sleep(3000);
            case 8:
              _context.next = 10;
              return this.updateQuota();
            case 10:
              this._ready = true;
              this.heartbeatTimer = setInterval(function () {
                return _this2.heartbeat();
              }, this.heartbeatInterval);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /** Send a ping to the shared Redis channel */
  }, {
    key: "ping",
    value: function ping() {
      this.client['publish'](this.channelName, JSON.stringify(this.uniqueId));
    }
    /** Receive client pings */
  }, {
    key: "message",
    value: function message(channel, _message) {
      if (channel !== this.channelName) {
        return;
      }
      var uniqueId;
      try {
        uniqueId = JSON.parse(_message);
      } catch (_a) {
        console.error("invalid JSON on Redis pub/sub channel ".concat(channel, ": ").concat(_message));
        return;
      }
      var newClient = !this.pingsReceived.has(uniqueId);
      this.pingsReceived.set(uniqueId, Date.now());
      if (newClient) {
        this.ping();
        if (this.ready) {
          this.updateQuota();
        }
      }
    }
    /** Remove outdated clients */
  }, {
    key: "removeOutdatedClients",
    value: function removeOutdatedClients() {
      var _this3 = this;
      var ancient = Date.now() - this.heartbeatInterval * 3;
      var expired = _toConsumableArray(this.pingsReceived).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];
        return v <= ancient;
      });
      expired.forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          k = _ref4[0],
          v = _ref4[1];
        return _this3.pingsReceived.delete(k);
      });
    }
    /** Calculate our portion of the overall channel quota */
  }, {
    key: "updateQuota",
    value: function updateQuota() {
      this.removeOutdatedClients();
      if (!this.pingsReceived.size) {
        return;
      }
      var newQuota = Object.assign({}, this.channelQuota);
      newQuota.rate = Math.floor(newQuota.rate / this.pingsReceived.size);
      if (newQuota.concurrency) {
        newQuota.concurrency = Math.floor(newQuota.concurrency / this.pingsReceived.size);
      }
      this._quota = newQuota;
    }
    /** Let the others know we’re here */
  }, {
    key: "heartbeat",
    value: function heartbeat() {
      this.ping();
      if (this.ready) {
        this.updateQuota();
      }
    }
  }]);
  return RedisQuotaManager;
}(quotaManager_1.QuotaManager);
exports.RedisQuotaManager = RedisQuotaManager;